import { ChevronRightIcon } from '../icons/ChevronRightIcon'
import { PlusOutlineIcon } from '../icons/PlusOutlineIcon'
import { OmneoList } from '../types'

type WishlistListRowProps = {
  list: Pick<OmneoList, 'name' | 'is_shared' | 'items'>
  image: {
    src: string
    alt?: string
  }
  onClick: () => void
  className?: string
  imageWrapperClassName?: string
  imageClassName?: string
  contentClassName?: string
  chevronClassName?: string
  trailingIcon?: 'chevron' | 'plus'
}

export function WishlistListRow({
  list,
  image,
  onClick,
  className = 'flex items-center cursor-pointer w-full',
  imageWrapperClassName = 'relative h-[93px] w-[74px] bg-light',
  imageClassName = 'absolute top-0 left-0 object-cover w-full h-full',
  contentClassName = 'flex-1 px-2.5 py-[5px] md:px-5',
  chevronClassName = 'w-2.5 h-2.5 text-ink',
  trailingIcon = 'chevron'
}: WishlistListRowProps) {
  return (
    <div className={className} onClick={onClick}>
      <div className={imageWrapperClassName}>
        <img className={imageClassName} src={image.src} alt={image.alt} loading="lazy" />
      </div>
      <div className={contentClassName}>
        <h4 className="m-0 text-[14px] lg:text-[16px] text-ink font-light font-sans uppercase">{list.name}</h4>
        <div className="flex items-center mt-2.5 text-subdued text-xs font-light font-calibre">
          <p className="m-0 text-subdued text-xs font-light font-calibre">{list.is_shared ? 'Public' : 'Private'}</p>
          <span className="w-0.5 h-0.5 rounded-full bg-subdued mx-[5px]"></span>
          <span>
            {list.items.length} {list.items.length === 1 ? 'item' : 'items'}
          </span>
        </div>
      </div>
      {trailingIcon === 'plus' ? <PlusOutlineIcon className={chevronClassName} /> : <ChevronRightIcon className={chevronClassName} />}
    </div>
  )
}